var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ReactComponent as Hurricane04 } from '@backrs_ui/common-ui/src/assets/customAppIcons/hurricane-04.svg';
import { ReactComponent as Hurricane05 } from '@backrs_ui/common-ui/src/assets/customAppIcons/hurricane-05.svg';
import { ReactComponent as US } from '@backrs_ui/common-ui/src/assets/customAppIcons/US.svg';
import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { UNTITLED_UI_ICONS } from '@backrs_ui/common-ui/src/designSystem/icons/untitledUIIconList';
export var CUSTOM_ICON_NAMES = {
    Hurricane04: Hurricane04,
    Hurricane05: Hurricane05,
    US: US,
};
export var ICON_SIZES = {
    '8px': '8px',
    '10px': '10px',
    '12px': '12px',
    '14px': '14px',
    '16px': '16px',
    '18px': '18px',
    '20px': '20px',
    '24px': '24px',
    '28px': '28px',
    '32px': '32px',
    '40px': '40px',
    '48px': '48px',
    '56px': '56px',
    '64px': '64px',
    '96px': '96px',
};
export var AppIcon = function (_a) {
    var iconName = _a.iconName, diameter = _a.diameter, color = _a.color, rotate = _a.rotate, fill = _a.fill, _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 'regular' : _b;
    var IconComponent = iconName in UNTITLED_UI_ICONS
        ? UNTITLED_UI_ICONS[iconName]
        : CUSTOM_ICON_NAMES[iconName];
    if (!IconComponent) {
        return null;
    }
    return (_jsx(IconComponent, __assign({ width: diameter, height: diameter, color: color === 'currentColor' ? 'currentColor' : COLOR_TOKENS[color], transform: rotate ? "rotate(".concat(rotate, ")") : undefined, className: strokeWidth ? "untitled-icon-stroke-width-".concat(strokeWidth) : '' }, (fill ? { fill: fill === 'currentColor' ? 'currentColor' : COLOR_TOKENS[fill] } : {}))));
};
